import { BrowserRouter, Route, Routes} from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import  Home  from "./Home";
import Android from "./Android";
import MainContent from "./Maincontent";
import AboutAlvanium from "./AboutAlvanium";
import CustomSolutions from "./CustomSolutions";
import Contact from "./Contact";
import Products from "./Products"
import ProductPage from "./ProductPage";
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import AppDetailPage from "./AppDetailPage";
// import CookiePolicy from './CookiePolicy';
 
const App = () => {
  return (
    <BrowserRouter>
    <ScrollToTop /> 
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/" element={<MainContent />} /> */}
        
        <Route path="android" element={<Android />} />
        <Route path="aboutalvanium" element={<AboutAlvanium/>}/>
        <Route path="customsolutions" element={<CustomSolutions/>}/>
        <Route path="contact" element={<Contact/>}/>
        <Route path="products" element={<Products/>}/>
        
        {/* Fixed: Changed to match both possible navigation paths */}
        <Route path="/products/:id" element={<ProductPage />} />
        <Route path="/product/:id" element={<ProductPage />} /> {/* Added this as fallback */}
        
        {/* About page */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/products" element={<Products />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        {/* <Route path="/cookies" element={<CookiePolicy />} /> */}
        
        <Route path="/product/:productId/app/:appId" element={<AppDetailPage />} />

      </Routes>
    </BrowserRouter>
  )
}
 
export default App;